const NotShowingBubbles = [
  "What is your preferred method of contact for your results session?",
  "If you feel it is relevant, please describe to which religious group you belong.",
];

export { NotShowingBubbles };
